<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'project.home.importProject' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <div class="form-group">
            <span class="form-label">{{ 'project.name' | translate }}</span>
            <sui-string-component [config]="name"></sui-string-component>
        </div>
        <div class="form-group">
            <span class="form-label">{{ 'project.description' | translate }}</span>
            <sui-string-component [config]="description"></sui-string-component>
        </div>
        <div class="form-group">
            <span class="form-label">{{ 'project.file' | translate }}</span>
            <winde-file-chooser [accept]="acceptedMimeTypes" [config]="file"></winde-file-chooser>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <sui-checkbox-component [(isChecked)]="shouldOpenProject" label="project.openAfter.import">
        </sui-checkbox-component>
        <div>
            <button matDialogClose windeTransparent>
                <sui-svg-icon icon="cross"/>
                {{ 'entity.action.cancel' | translate }}
            </button>
            <button (click)="import()" [disabled]="!file.value" windeGreen>
                <sui-svg-icon icon="save"/>
                {{ 'entity.action.import' | translate }}
            </button>
        </div>
    </div>
</div>
